<template>
  <div>
    <div v-if="!imgSrc" class="container-block">
      <div v-if="!hideTitle" class="container-block-title">{{ title }}</div>

      <v-file-input
        v-show="!hideInput"
        :accept="accept"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        v-model="newImage"
        @change="previewImage"
        ref="fileInput"
        :label="inputPlaceholderText"
      ></v-file-input>
      <div class="container-block-gallery-button" @click="openGallery">
        {{ bottomText }}
      </div>
    </div>

    <div></div>

    <div v-if="imgSrc" class="container-block" style="width: 100%">
      <div class="container-block-title" v-if="!hideTitleHint">
        Кадрировать изображение
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td
                class="text-left"
                style="width: fit-content; max-width: 260px"
              >
                {{ format }}
              </td>
              <td
                class="text-left"
                style="width: fit-content; max-width: 260px"
              >
                {{ placeToDisplay }}
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!imageSrcMobile"
                  @click="openMobileImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(false)"
                    class="table-img"
                    :src="imageSrcMobile"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!imageSrcTablet"
                  @click="openTabletImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(false)"
                    class="table-img"
                    :src="imageSrcTablet"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogMobile"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobile"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 76,
                    height: 84,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobile"
                />
              </div>

              <div
                class="d-flex justify-center"
                style="width: 100%"
                v-if="resultImageMobile"
              >
                <img width="76px" height="84px" :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogTablet"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperTablet"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 90,
                    height: 100,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTablet"
                />
              </div>

              <div
                class="d-flex justify-center"
                style="width: 100%"
                v-if="resultImageTablet"
              >
                <img width="90px" height="100px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    item: {},

    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogTablet: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    imageSrcMobile: "",
    imageSrcTablet: "",

    smartphoneMainImage: null,
    tabletMainImage: null,
    formData: new FormData(),
  }),

  props: {
    imgSrcProp: {
      type: String || File,
    },
    imgSrcMobileProp: {
      type: String,
    },
    imgSrcTabletProp: {
      type: String,
    },
    title: {
      type: String,
      default: "Изображение",
    },
    inputPlaceholderText: {
      type: String,
      default: "Прикрепить изображение",
    },
    bottomText: {
      type: String,
      default: "Выбрать изображение из галереи",
    },
    accept: {
      type: String,
      default: "image/*",
    },
    hideInput: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    hideTitleHint: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
    width: {
      type: String,
      default: "50%",
    },
    placeToDisplay: {
      type: String,
      default: "Отображается в списке и разделе «Выборы КСА»",
    },
    format: {
      type: String,
      default: "Фото",
    },
  },

  methods: {
    openGallery() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.imageSrcMobile = "";
      this.imageSrcTablet = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },
    openMobileImg() {
      this.dialogMobile = true;
      setTimeout(() => {
        this.$refs.cropperMobile.refresh();
      }, 500);

      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      setTimeout(() => {
        this.$refs.cropperTablet.refresh();
      }, 500);
      this.errImages = false;
    },

    closeTabletImg() {
      this.imageSrcTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.set("tabletImage", blob);
          this.finishImageTablet = blob;
          this.tabletMainImage = true;
        },
        "image/webp",
        0.95
      );
    },

    closeMobileImg() {
      this.imageSrcMobile = this.resultImageMobile;
      this.dialogMobile = false;

      const { canvas } = this.$refs.cropperMobile.getResult();
      canvas.toBlob(
        (blob) => {
          this.formData.set("smartphoneImage", blob);
          this.finishImageMobile = blob;
          this.smartphoneMainImage = true;
        },
        "image/webp",
        0.95
      );
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },

    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
  },

  watch: {
    newImage() {
      this.$emit("imageDesktopBlob", this.newImage);
    },
    finishImageMobile() {
      this.$emit("imageMobileBlob", this.finishImageMobile);
    },
    finishImageTablet() {
      this.$emit("imageTabletBlob", this.finishImageTablet);
    },
  },
  created() {
    this.imgSrc = this.imgSrcProp;
    this.imageSrcMobile = this.imgSrcMobileProp;
    this.imageSrcTablet = this.imgSrcTabletProp;
  },
};
</script>
<style scoped lang="scss">
.container-block {
  width: v-bind(width);
  margin-bottom: 20px;

  .container-block-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .container-block-gallery-button {
    text-decoration: underline;
    color: #1064dd;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
    padding-bottom: 20px;
  }

  .table-img {
    // width: 62px;
    height: 38px;
    object-fit: contain;
  }
}
</style>
